const headerData = [{
		prop: "ID",
		label: "附件编号",
		columnwidth: 150,
	},
	{
		prop: "FileName",
		label: "附件名称",
	},
	{
		prop: "FileUrl",
		label: "附件路径",
		columnwidth: 220,
	},
	{
		prop: "Extension",
		label: "附件扩展名",
		columnwidth: 100,
	},
	{
		prop: "czAll",
		label: "操作",
		columnwidth: 120,
	}
];
export default headerData;